import { ChevronRight } from "lucide-react";
import { type ColumnDef } from "@tanstack/react-table";
import Skeleton from "react-loading-skeleton";
import { TableSkeleton } from "../tables";

export interface DataViewGroupSkeletonProps<T> {
  columns: ColumnDef<T>[];
  rows: number;
}

export function DataViewGroupSkeleton<T>({
  columns,
  rows,
}: DataViewGroupSkeletonProps<T>) {
  return Array.from({ length: rows }).map((_, index) => (
    <div
      key={index}
      className={"grid mb-10 rounded-sm"}
      style={{
        borderLeft: `6px solid transparent`,
      }}
    >
      <div
        className={`flex cursor-pointer w-full px-2 py-1 text-left transition sticky bg-white top-30 left-0 z-40 border-1 border-gray-200`}
      >
        <ChevronRight
          className={`h-5 w-5 mt-1 mr-2 text-gray-500 transition-transform duration-100 hover:cursor-pointer rotate-90`}
        />
        <span className="group text-gray-500">
          <h2 className="font-medium text-lg">
            {<Skeleton width={150} height={24} />}
            <span className="text-sm text-gray-400 px-2 py-0.5 ml-2 opacity-0 group-hover:opacity-100 transition">
              <Skeleton width={50} height={2} />
            </span>
          </h2>
        </span>
      </div>

      <TableSkeleton rowCount={10} columnDefs={columns} />
    </div>
  ));
}
